import { useParams, Link } from "react-router-dom";
import { SEO } from "@/components/SEO";
import { PageHero } from "@/components/sections/PageHero";
import { useLocation_, useServices } from "@/hooks/useData";
import { IMG, servicePath } from "@/lib/content";
import { Reveal } from "@/components/motion/Reveal";
import { Button } from "@/components/motion/Button";
import { Process } from "@/components/sections/Process";
import { FAQ } from "@/components/sections/FAQ";
import { QuoteSection } from "@/components/sections/QuoteSection";
import { FinalCta } from "@/components/sections/FinalCta";
import NotFound from "@/pages/NotFound";

export default function LocationPage() {
  const { slug } = useParams();
  const { data: loc, isLoading, isError } = useLocation_(slug);
  const { data: services = [] } = useServices();
  if (isError) return <NotFound />;
  if (isLoading || !loc) return <div className="min-h-screen bg-ink" />;
  return (
    <>
      <SEO title={loc.seo_title.replace(" | Emini Reinigung", "")} description={loc.seo_description} path={`/standorte/${slug}`} />
      <PageHero label={`Standort · ${loc.postal_code} ${loc.name}`} title={["Reinigungsfirma", `${loc.name}.`]} image={IMG.hero} imageAlt={`Reinigung in ${loc.name}`} lead={loc.intro}>
        <Button to="/kontakt" variant="light" data-testid="location-cta">Offertanfrage</Button>
      </PageHero>
      <section className="bg-paper py-24 md:py-36">
        <div className="container-x grid lg:grid-cols-12 gap-14">
          <Reveal className="lg:col-span-3"><p className="label text-mute">Leistungen in {loc.name}</p></Reveal>
          <ul className="lg:col-span-8 lg:col-start-5 border-t border-line">
            {services.map((s) => (
              <li key={s.slug} className="border-b border-line">
                <Link to={servicePath(s.slug)} className="group flex items-baseline gap-5 py-5">
                  <span className="label text-mute group-hover:text-signal transition-colors">{s.number}</span>
                  <span className="display text-2xl md:text-3xl uppercase tracking-[-0.02em] text-ink/70 group-hover:text-ink group-hover:translate-x-2 transition-[transform,color] duration-700 ease-out">{s.name} {loc.name}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </section>
      <Process />
      <FAQ />
      <QuoteSection />
      <FinalCta />
    </>
  );
}
